import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CompanyTierSettingService } from '../services/company-tier-setting.service';

// CRAT-1127 — gates the manual-order (offline POS) page on the offline-stores tier flag.
@Injectable({
  providedIn: 'root',
})
export class OfflineStoresEnabledGuard {
  private authService = inject(AuthService);
  private companyTierSettingService = inject(CompanyTierSettingService);
  private router = inject(Router);

  async canActivate(): Promise<boolean> {
    let enabled = false;
    try {
      enabled = await this.companyTierSettingService.isOfflineStoresEnabled(this.authService.user.companyId);
    } catch (error) {
      console.error(error);
    }
    if (enabled) {
      return true;
    }
    return this.router.navigate(['/orders']);
  }
}
